"use strict";
/**
 * This file is generated automatically. Do not change it manually!
 * Этот файл генерируется автоматически. Не изменяйте его вручную!
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Permissions.js.map